<template>
  <div class="container">
    <content-header :data="[{text: '投票活动一览', path: '/vote/list'},{text:(curObj.id ? '修改':'添加')+'投票', path: ''}]"></content-header>
    <div class="content">
      <el-form :model="curObj" :rules="curObjRules" ref="curObjForm" label-position="right" label-width="0px">
        <el-form-item prop="name" label="投票名称" :label-width="formLabelWidth">
          <el-input name="name" v-model="curObj.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="活动时间" :label-width="formLabelWidth" required>
          <el-col :span="6">
            <el-form-item prop="startTime">
              <el-date-picker type="date" placeholder="开始日期" v-model="curObj.startTime" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="1"><span>至</span></el-col>
          <el-col :span="6">
            <el-form-item prop="endTime">
              <el-date-picker placeholder="结束日期" v-model="curObj.endTime" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item label="报名时间" :label-width="formLabelWidth" required>
          <el-col :span="6">
            <el-form-item prop="signupStart">
              <el-date-picker type="date" placeholder="开始日期" v-model="curObj.signupStart" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="1"><span>至</span></el-col>
          <el-col :span="6">
            <el-form-item prop="signupEnd">
              <el-date-picker placeholder="结束日期" v-model="curObj.signupEnd" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>


        <el-form-item prop="imageUrl" label="封面图" :label-width="formLabelWidth">
          <el-upload
            class="avatar-uploader"
            action="//upload-z2.qiniup.com"
            :data="uploadForm"
            :show-file-list="false"
            :on-success="uploadPhotoSuccess"
            :before-upload="beforePhotoUpload"
            :on-error="uploadError">
            <img v-if="curObj.imageUrl" :src="curObj.imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item prop="description" label="活动说明" :label-width="formLabelWidth">
          <ky-editor v-model="curObj.description"
            ref="myQuillEditor">
          </ky-editor>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-button @click="isObjShow = false">取 消</el-button>
          <el-button type="primary" @click="confirmHandle">确 定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type="text/babel">
  import date from 'utils/date'
  import VoteModel from 'models/vote'
  import CommonModel from 'models/common'
  import KyEditor from 'components/KyEditor'

  export default {
    components: {
      KyEditor,
    },
    data () {
      var validateEndTime = (rule, value, callback) => {
        if (value === '') {
          // callback(new Error('请再次输入密码'));
        } else if (value <= this.curObj.startTime) {
          callback(new Error('结束日期必须晚于开始日期!'))
        } else {
          callback()
        }
      }
      var validateSignupEndTime = (rule, value, callback) => {
        if (value === '') {
          // callback(new Error('请再次输入密码'));
        } else if (value <= this.curObj.signupStart) {
          callback(new Error('结束日期必须晚于开始日期!'))
        } else {
          callback()
        }
      }
      return {
        isObjShow: false,
        categoryIds: [],
        curObj: {
          id: '',
          name: '',
          startTime: '',
          endTime: '',
          signupStart: '',
          signupEnd: '',
          imageUrl: '',
          description: ''
        },
        formLabelWidth: '80px',
        curObjRules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          startTime: [{ required: true, message: '请输入开始日期', trigger: 'blur' }],
          endTime: [{ required: true, message: '请输入结束日期', trigger: 'blur' },
            { validator: validateEndTime, trigger: 'blur' }],
          signupStart: [{ required: true, message: '请输入开始日期', trigger: 'blur' }],
          signupEnd: [{ required: true, message: '请输入结束日期', trigger: 'blur' },
            { validator: validateSignupEndTime, trigger: 'blur' }],
          imageUrl: [{ required: true, message: '请上传图片', trigger: 'blur' }],
          description: [{ required: true, message: '请输入活动说明', trigger: 'blur' }],
        },
        //
        uploadForm: {key: '', token: ''},
        qiniuHost: '',
        datePickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
      }
    },
    created () {
      //
      this.curObj.id = this.$route.query.id
      console.log(this.curObj.id)
      if (this.curObj.id) {
        VoteModel.get({
          voteId: this.curObj.id
        }).then(res => {
          this.curObj = res
          this.curObj.startTime = this.curObj.startTime.substr(0, 10)
          this.curObj.endTime = this.curObj.endTime.substr(0, 10)
          this.curObj.signupStart = this.curObj.signupStart.substr(0, 10)
          this.curObj.signupEnd = this.curObj.signupEnd.substr(0, 10)
          console.log(this.curObj)
        })
      }
    },
    methods: {
      uploadRemove (file, fileList) {
        console.log(file)
      },
      uploadError (err, file, fileList) {
        console.log(err)
      },
      uploadExceed (files, fileList) {
        console.log(files.length)
      },
      uploadPhotoSuccess (response, file, fileList) {
        // console.log(response)
        this.curObj.imageUrl = this.qiniuHost + response.key
      },
      beforePhotoUpload (file) {
        const isPic = (file.type === 'image/jpeg' || file.type === 'image/png')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isPic) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
          return false
        }
        //
        let curr = date(new Date().getTime(), 'yyyyMMdd')
        let prefix = 'vote'
        let ext = file.name.split('.').pop()
        let suffix = this.$md5(file.name)
        if (!this.uploadForm.token) {
          return CommonModel.getQiniuUptoken().then(res => {
            this.qiniuHost = res.qiniuHost
            this.uploadForm.token = res.uptoken
            this.uploadForm.key = encodeURI(`${prefix}/${curr}_${suffix}.${ext}`)
            // console.log(this.uploadForm)
          })
        } else {
          this.uploadForm.key = encodeURI(`${prefix}/${curr}_${suffix}.${ext}`)
          // console.log(this.uploadForm)
        }
        return true
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      newHandle () {
        VoteModel.create({
          name: this.curObj.name,
          startTime: this.curObj.startTime + ' 00:00:00',
          endTime: this.curObj.endTime + ' 23:59:59',
          signupStart: this.curObj.signupStart + ' 00:00:00',
          signupEnd: this.curObj.signupEnd + ' 23:59:59',
          imageUrl: this.curObj.imageUrl,
          description: this.curObj.description
        }).then(() => {
          this.$router.push({ name: 'vote.list' })
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      editHandle () {
        VoteModel.update({
          id: this.curObj.id,
          name: this.curObj.name,
          startTime: this.curObj.startTime + ' 00:00:00',
          endTime: this.curObj.endTime + ' 23:59:59',
          signupStart: this.curObj.signupStart + ' 00:00:00',
          signupEnd: this.curObj.signupEnd + ' 23:59:59',
          imageUrl: this.curObj.imageUrl,
          description: this.curObj.description
        }).then(() => {
          this.$message({ message: '更新成功', type: 'success' })
          this.$router.push({ name: 'vote.list' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    padding: 20px
    font-size: 14px
    .el-input
      width: 50%
    .textarea
      width: 80%
    .avatar-uploader
        border: 1px dashed #d9d9d9
        border-radius: 6px
        cursor: pointer
        position: relative
        overflow: hidden
        width: 240px
        &:hover
          border-color: #409EFF
        .avatar-uploader-icon
          font-size: 28px
          color: #8c939d
          width: 240px
          height: 178px
          line-height: 178px
          text-align: center
        .avatar
          width: 240px
          height: 178px
          display: block
</style>



// WEBPACK FOOTER //
// src/views/VoteNew.vue